import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { authorizedAxios, useAuth } from "@moonscape/shared";

type UseTaxReportDataOptions = {
  taxYear: number;
  enabled?: boolean;
};

export type TaxReportDataResponse = {
  fileName: string;
  taxYear: number;
  taxSetting: any;
  cgtReport: any;
  taxEvents: any[];
  incomeReport: any;
  incomeEvents: any[];
};

export const useTaxReportData = ({
  taxYear,
  enabled = true,
}: UseTaxReportDataOptions): UseQueryResult<TaxReportDataResponse, Error> => {
  const { getToken, user } = useAuth();

  const fetchTaxReportData = async (): Promise<TaxReportDataResponse> => {
    const token = await getToken();
    const response = await authorizedAxios(token).get(
      "/export/tax-report/data",
      {
        params: { year: taxYear },
      }
    );

    return response.data;
  };

  return useQuery({
    queryKey: ["tax_report_data", taxYear],
    queryFn: fetchTaxReportData,
    enabled: enabled && !!user?.email && Number.isFinite(taxYear),
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });
};
